import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlassChart,
  faRoute,
  faPalette,
  faRocket,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import "./Process.css";

const steps = [
  {
    title: "Understand Your Setup",
    description: "A quick analysis of your tools, devices, apps & workflows.",
    icon: faMagnifyingGlassChart,
  },
  {
    title: "Audit & Prioritize",
    description:
      "We map out issues, security gaps, and improvements by priority.",
    icon: faRoute,
  },
  {
    title: "Plan the Right Solution",
    description:
      "Clear plan covering IT support, web, CRM, security, or accounting.",
    icon: faPalette,
  },
  {
    title: "Implement & Train",
    description:
      "We set up everything, configure tools, and guide your team.",
    icon: faRocket,
  },
  {
    title: "Ongoing Support & Reports",
    description:
      "Monthly support, check-ins, updates, and easy-to-read reports.",
    icon: faChartLine,
  },
];

const Process = () => {
  return (
    <section className="process-new">
      <div className="process-new-header">
        <span className="process-new-pill">How we work</span>
        <h2>Clear, structured delivery — every time.</h2>
        <p>
          A transparent workflow that keeps your IT, web, security, and
          operations running smoothly.
        </p>
      </div>

      <div className="process-new-grid">
        {steps.map((step, index) => (
          <motion.div
            key={index}
            className="process-new-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.08 }}
          >
            <div className="process-new-number">{index + 1}</div>

            <div className="process-new-icon">
              <FontAwesomeIcon icon={step.icon} />
            </div>

            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Process;
